<template>
  <list-select emit-only-value ref="select" v-on:input="(v) => $emit('input', v)" :search-data="search"
              :placeholder="placeholder" :search-only-select="true" v-model="model" :parse-callback="parse"/>
</template>

<script>
import ListSelect from "@/reuse/input/ListSelect"
import {listDocumentos} from "@/domain/documento/services"

export default {
  name: "DocumentoSelect",
  props: {
    value: {
      required: true
    },
    code: {
      required: false
    },
    placeholder: {
      default: 'Padrão do sistema'
    }
  },
  data() {
    return {
      model: this.value
    }
  },
  watch: {
    value(v) {
      this.$nextTick(() => {
        if (v !== this.model) {
          this.$refs.select.autoSelectValue(v)
        }
      })
    }
  },
  components: {ListSelect},
  methods: {
    parse (v) {
      return v && v.name ? `${v.name}${v.code ? ' ['+ v.code + ']' : ''}` : v
    },
    search(terms) {
      console.log(terms)
      return new Promise((resolve, reject) => {
        const filtros = []
        if (this.code) filtros.push('codigo-categoria=' + this.code)
        listDocumentos(100, 1,  '&' + filtros.join('&'))
            .then(response => {
              console.log(response.data)
              if (!response.data) return []
              let list = response.data.result
              // let list = this.tipo ? response.data.filter(c => Number(c.tipo) === Number(this.tipo)) : response.data
              list = list.map(doc => {
                return {
                  ...doc,
                  label: `${doc.name} [Código: ${doc.code}]`,
                  value: doc.id
                }
              })
              list.unshift({
                name: 'Padrão do sistema',
                label: 'Padrão do sistema',
                value: null,
                disabled: true,
                selectable: true
              })
              resolve(list)
            })
            .catch(error => {
              this.alertApiError(error)
              reject(error)
            })
      })
    }
  }
}
</script>
